import React, { createContext, useState } from "react";
import * as CryptoJS from "crypto-js";

export const MyContext = createContext();

const AllScanContext = ({ children }) => {
  const [key, setKey] = useState(null);
  const apiKey = process.env.REACT_APP_SESSION_KEY;
  function generateKey() {
    return crypto.subtle
      .generateKey(
        {
          name: "AES-GCM",
          length: 256,
        },
        true,
        ["encrypt", "decrypt"]
      )
      .then((generatedKey) => {
        setKey(generatedKey);
        return generatedKey;
      });
  }

  function stringToArrayBuffer(str) {
    let encoder = new TextEncoder();
    return encoder.encode(str);
  }

  function arrayBufferToString(buffer) {
    let decoder = new TextDecoder();
    return decoder.decode(buffer);
  }

  function encryptData(data, key) {
    let encodedData = stringToArrayBuffer(data);
    let iv = crypto.getRandomValues(new Uint8Array(12));

    return crypto.subtle
      .encrypt(
        {
          name: "AES-GCM",
          iv: iv,
        },
        key,
        encodedData
      )
      .then((encryptedData) => {
        return {
          iv: Array.from(iv),
          encryptedData: Array.from(new Uint8Array(encryptedData)),
        };
      });
  }

  function decryptData(encryptedData, key, iv) {
    iv = new Uint8Array(iv);
    encryptedData = new Uint8Array(encryptedData);

    return crypto.subtle
      .decrypt(
        {
          name: "AES-GCM",
          iv: iv,
        },
        key,
        encryptedData
      )
      .then((decryptedData) => {
        return arrayBufferToString(decryptedData);
      });
  }

  function encryptWithCryptoJS(txt) {
    let _key = apiKey;
    return CryptoJS.AES.encrypt(txt, _key).toString();
  }

  function decryptWithCryptoJS(txtToDecrypt) {
    let _key = apiKey;
    return CryptoJS.AES.decrypt(txtToDecrypt, _key).toString(CryptoJS.enc.Utf8);
  }

  function setEncryptedItem(key, value) {
    const encryptedValue = encryptWithCryptoJS(value);
    localStorage.setItem(key, encryptedValue);
  }

  function getDecryptedItem(key) {
    const encryptedValue = localStorage.getItem(key);
    return encryptedValue ? decryptWithCryptoJS(encryptedValue) : null;
  }

  function setEncryptedSessionItem(key, value) {
    const encryptedValue = encryptWithCryptoJS(value);
    sessionStorage.setItem(key, encryptedValue);
  }

  function getDecryptedSessionItem(key) {
    const encryptedValue = sessionStorage.getItem(key);
    return encryptedValue ? decryptWithCryptoJS(encryptedValue) : null;
  }

  return (
    <MyContext.Provider
      value={{
        generateKey,
        encryptData,
        decryptData,
        setEncryptedItem,
        getDecryptedItem,
        setEncryptedSessionItem,
        getDecryptedSessionItem,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default AllScanContext;
